"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const config_1 = require("./confistore/config");
const writableConfig_1 = require("./confistore/writableConfig");
exports.config = {
    getItem: config_1.getItem
};
exports.writableConfig = {
    init: writableConfig_1.init
};
